export const TasksActionTypes = {
    FETCH_TASKS_START: 'FETCH_TASKS_START',
    FETCH_TASKS_SUCCESS: 'FETCH_TASKS_SUCCESS',
    ADD_TASK: 'ADD_TASK',
    DELETE_TASK: 'DELETE_TASK',
    EDIT_TASK: 'EDIT_TASK',
    DATABASE_FAILURE: 'DATABASE_FAILURE',
    CLEAR_COMPLETED_TASKS: 'CLEAR_COMPLETED_TASKS',
    SET_CURRENT_TASK: 'SET_CURRENT_TASK',
    SET_THEME: 'SET_THEME'
};